<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Bhandara District 1st G. H. Raisoni Memorial Rapid Chess Tournament 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>Bhandara District 1st G. H. Raisoni Memorial Rapid Chess Tournament 2026 </span></h2>
        </div>

        <p><strong>Date: </strong>19 April 2026</p>
        <p><strong>Venue: </strong>Shakuntala Sabhagruha, Bhandara Road, Tumsar</p>
        <p><strong> Organized By: </strong>Tumsar Chess Organization</p>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Prize List</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tumsar-signature-sheet.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
